@if (tabs && tabs.length > 0) {
  <div class="nk-tab-menu d-none d-md-flex">
    @for (tab of tabs; track tab; let index = $index) {
      <nk-tab [tabIndex]="index" [tab]="tab" (tabClicked)="onTabClicked($event)"></nk-tab>
    }
  </div>
}

@if (tabs && currentTabItem(); as currentTabItem) {
  <div class="dropdown w-100 d-md-none" dropdown>
    @if (currentTabItem.data) {
      <button
        dropdownToggle
        type="button"
        aria-controls="dropdown-watchlist"
        class="btn btn-primary dropdown-toggle w-100">
        @if (currentTabItem.data.faicon) {
          <i [ngClass]="'fa fa-' + currentTabItem.data.faicon"></i>
        }
        {{ currentTabItem.data.title || '' | translate }}
      </button>
    }
    <ul *dropdownMenu class="dropdown-menu w-100" aria-labelledby="dropdown-watchlist-button" role="menu">
      @for (tab of tabs; track tab; let index = $index) {
        <li>
          <nk-tab [tabIndex]="index" [tab]="tab" (tabClicked)="onTabClicked($event)"></nk-tab>
        </li>
      }
    </ul>
  </div>
}
